import {useEffect, useRef} from "react";

export const usePrevious = (value) => {
    const ref = useRef();
    //console.log('usePrevious useEffect', ref.current, value);
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  }